import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#FFD700]/20 py-10 px-4" data-id="element-195">
      <div className="max-w-3xl mx-auto text-center" data-id="element-196">
        <div className="text-[#FFD700] text-2xl font-black tracking-widest mb-4" data-id="element-197">
          🥁 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-198">
          El sistema de clases N°1 para profesores de batería en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-199">
          Porque enseñar batería no debería costarte todos los domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-200">
          <span data-id="element-201">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-202">•</span>
          <span data-id="element-203">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-204">•</span>
          <span data-id="element-205">🌐 www.profepack.com</span>
        </div>

        <div className="h-px bg-[#FFD700]/20 mb-6" data-id="element-206" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-207">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-208">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}